import { useEffect, useState } from "react";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { getOptionsMaster, getProfessionList } from "../../../reducers/talentJob";
import { RECRUITMENT_STATUS_OPTION_TYPE } from '../../../constants/index';

export const TypeOptions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const {
    optionsMaster,
    optionsProfesstion,
  } = useSelector((state: any) => state.talentJob);

  
  useEffect(() => {
    const data = {
      option: 'job_status,job_type,job_role,job_working_style,job_salary_payment_method,japan_city,job_void_smoking_policy,job_days_off_pattern',
    }
    dispatch(getOptionsMaster(data));
    dispatch(getProfessionList({}));
  }, []);

  const recruitmentStatus = optionsMaster
    .filter((option: any) => option.name === RECRUITMENT_STATUS_OPTION_TYPE)
    .flatMap((option: any) => 
      option.option_list.map((subOption: any) => ({
        name: subOption.label,
        id: subOption.id,
        value: subOption.value,
      }))
    );

  const employmentStatus = optionsMaster
    .filter((option: any) => option.name === 'job_type')
    .flatMap((option: any) => 
      option.option_list.map((subOption: any) => ({
        name: subOption.label,
        id: subOption.id,
      }))
    );

  const roleOptions = optionsMaster
    .filter((option: any) => option.name === 'job_role')
    .flatMap((option: any) => 
      option.option_list.map((subOption: any) => ({
        name: subOption.label,
        id: subOption.id,
      }))
    );

  const workingStyles = optionsMaster
    .filter((option: any) => option.name === 'job_working_style')
    .flatMap((option: any) => 
      option.option_list.map((subOption: any) => ({
        name: subOption.label,
        id: subOption.id,
      }))
    );

  const payTypes = optionsMaster
    .filter((option: any) => option.name === 'job_salary_payment_method')
    .flatMap((option: any) => 
      option.option_list.map((subOption: any) => ({
        name: subOption.label,
        id: subOption.id,
      }))
    );

  const prefectures = optionsMaster
    .filter((option: any) => option.name === 'japan_city')
    .flatMap((option: any) => 
      option.option_list.map((subOption: any) => ({
        name: subOption.label,
        id: subOption.id,
      }))
    );

  const voidSmokingPolicy = optionsMaster
    .filter((option: any) => option.name === 'job_void_smoking_policy')
    .flatMap((option: any) => 
      Array.isArray(option.option_list) ? option.option_list.map((subOption: any) => ({
        name: subOption.label,
        id: subOption.id,
        code: subOption.value,
      })) : []
    );

  const daysOffPattern = optionsMaster
    .filter((option: any) => option.name === 'job_days_off_pattern')
    .flatMap((option: any) => 
      option.option_list.map((subOption: any) => ({
        name: subOption.label,
        id: subOption.id,
        code: subOption.value,
      }))
    );

  const fixedOTpayment = [
    {'label': '有', 'value': true},
    {'label': '無', 'value': false}
  ];

  const hasSalaryIncrement = [
    {'label': '有', 'value': true},
    {'label': '無', 'value': false}
  ];

  const probationDuration = [
    {'label': '有', 'value': true},
    {'label': '無', 'value': false}
  ];

  const [measuresAgainstPassiveSmoking, setMeasuresAgainstPassiveSmoking] = useState<any[]>([]);
  const [holidayAndVacationsRadioOptions, setHolidayAndVacationsRadioOptions] = useState<any[]>([]);
  
  // radio group
  useEffect(() => {
    if (voidSmokingPolicy) {
      const updatedMeasures = voidSmokingPolicy.map((item: any) => {
        const result: any = {
          label: item.name,
          value: item.id,
          code: item.code,
        };
        if (item.code === "no_smoking_premise") {
          result.note = "※勤務先が官庁・学校・病院のみ選択可";
        } else if (item.code === "no_solution") {
          result.note = "※勤務先が日本国外のみ選択可";
        } else {
          result.note = "";
        }
        return result;
      });
      setMeasuresAgainstPassiveSmoking(updatedMeasures);
    }

    if (daysOffPattern) {
      const updatedHoliday = daysOffPattern.map((item: any) => {
        const result: any = {
          label: item.name,
          value: item.id,
          code: item.code,
        };
        return result;
      });
      setHolidayAndVacationsRadioOptions(updatedHoliday);
    }
  }, [optionsMaster]);

  // checkbox
  const allowancesOptions = [
    {
      label: "通勤手当",
      value: false,
      name: "has_commuting_allowance",
    },
    {
      label: "住宅手当",
      value: false,
      name: "has_housing_allowance",
    },
    {
      label: "残業手当",
      value: false,
      name: "has_overtime_pay",
    },
    {
      label: "家族手当",
      value: false,
      name: "has_family_allowance",
    },
    {
      label: "営業手当",
      value: false,
      name: "has_sales_allowance",
    },
    {
      label: "地域手当",
      value: false,
      name: "has_regional_allowance",
    },
    {
      label: "退職金制度",
      value: false,
      name: "has_retirement_benefit",
    },
    {
      label: "寮社宅",
      value: false,
      name: "has_dorm_housing",
    },
  ];
  
  // checkbox
  const insuranceBenefitsOptions = [
    {
      label: "健康保険",
      value: false,
      name: "has_health_insurance",
    },
    {
      label: "厚生年金",
      value: false,
      name: "has_welfare_pension",
    },
    {
      label: "雇用保険",
      value: false,
      name: "has_employment_insurance",
    },
    {
      label: "労災保険",
      value: false,
      name: "has_accident_insurance",
    },
  ];

  // checkbox
  const maternityLeaveOptions = [
    {
      label: "産休育児休暇制度有",
      value: false,
      name: "has_maternity_leave",
    },
    {
      label: "産休育児休暇実績有",
      value: false,
      name: "has_maternity_leave_tracking",
    },
  ];

  const noAgeLimitOptions = [
    { label: "不問", value: false, name: "has_no_age_limit" },
  ];

  const increaseForOverTimeOptions = [
    {
      label: "固定残業時間を超えた分の割増賃金あり",
      value: false,
      name: "is_increase_for_over_ot",
    },
  ];

  const jobTypeOptions: any = optionsProfesstion;

  return {
    allowancesOptions,
    employmentStatus,
    holidayAndVacationsRadioOptions,
    insuranceBenefitsOptions,
    jobTypeOptions,
    maternityLeaveOptions,
    measuresAgainstPassiveSmoking,
    payTypes,
    prefectures,
    recruitmentStatus,
    workingStyles,
    noAgeLimitOptions,
    increaseForOverTimeOptions,
    roleOptions,
    fixedOTpayment,
    hasSalaryIncrement,
    probationDuration,
  };
}
